var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "auth-saas auth-linear", attrs: { id: "wrapper" } },
    [
      _c(
        "div",
        { staticClass: "auth-saas__layout auth-saas__layout--centered" },
        [
          _c("div", { staticClass: "auth-saas__form-column" }, [
            _c("div", { staticClass: "auth-saas__form-inner" }, [
              _c(
                "div",
                { staticClass: "auth-saas__card auth-linear__card" },
                [
                  _c("div", { staticClass: "auth-saas__badge" }, [
                    _vm._v(_vm._s(_vm.trans("auth.tnc"))),
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "auth-saas__title" }, [
                    _vm._v(_vm._s(_vm.trans("auth.tnc"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "auth-saas__subtitle" }, [
                    _vm._v(
                      "Review the admin usage terms before returning to the console."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "auth-linear__notice" }, [
                    _c("strong", [_vm._v(_vm._s(_vm.trans("auth.tnc")))]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Here goes terms and conditions!")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "auth-saas__btn-secondary d-block text-center",
                      attrs: { to: "/" },
                    },
                    [_vm._v(_vm._s(_vm.trans("general.back")))]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }